import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

export const translateByMessageId = (msgId) => {
  // some logic
  return <FormattedMessage id={msgId} />;
}

export default translateByMessageId;
